module.exports = __webpack_public_path__ + "static/media/Drones.41eaac3c.svg";